import { EventDispatcher, hideElement, isDesktopView, l, loadJavascript, logEvent, qs, qsa, setCookie } from '@utils/toolbox';
import { Modal } from '@js/components/modal';
import { eventCategories, events } from './event';

EventDispatcher.addEventListener('cookieNotice:accept', () => {
	console.log('cookieBasedFeatures:accept');
	console.log('cookieBasedFeatures:accept:loading:elements');
	qsa('[data-cookie]').forEach((element) => {
		element.removeAttribute('data-cookie');
	});

	// Load AdformV1 on desktop only
	if (isDesktopView() && js_params.adFormUrl) {
		console.log('cookieNotice:accept:loading:adform');
		loadJavascript({ src: js_params.adFormUrl }, { async: '', defer: '', id: 'adform-script' }, () => window?.adformtag?.addRequestGroup?.(js_params.adformMids));
	}

	// Load AdformV2 on all devices
	if (js_params.module?.AdformV2?.adformDMPEnabled && js_params.module?.AdformV2?.adformPageName) {
		window._adftrack = Array.isArray(window._adftrack) ? window._adftrack : (window._adftrack ? [window._adftrack] : []);
		const item = {
			HttpHost: 'track.adform.net',
			pm: 806852,
			divider: encodeURIComponent('|'),
			pagename: encodeURIComponent(js_params.module.AdformV2.adformPageName),
			order: {
				sv1: js_params.module.AdformV2.country,
				sv2: js_params.module.AdformV2.continent,
				sv3: js_params.module.AdformV2.fromcountry,
				sv4: js_params.module.AdformV2.fromcity,
				sv5: js_params.module.AdformV2.tocity,
				sv6: js_params.module.AdformV2.adults,
				sv7: js_params.module.AdformV2.children,
				sv8: js_params.module.AdformV2.leavedate,
				sv9: js_params.module.AdformV2.homedate,
				sv10: js_params.module.AdformV2.domain,
				sv11: js_params.module.AdformV2.path,
				sv12: js_params.module.AdformV2.fromIata,
				sv13: js_params.module.AdformV2.toIata
			}
		};
		window._adftrack.push(item);

		(function () {
			const s = document.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = 'https://s2.adform.net/banners/scripts/st/trackpoint-async.js'; const x = document.getElementsByTagName('script')[0]; x.parentNode.insertBefore(s, x);
		})();
	}

	// Load GTM
	if (js_params.gtmEnabled) {
		console.log('cookieNotice:accept:loading:GTM');
		loadJavascript(
			{
				src: `/static/v${js_params.version}/assets/resources/build/js/plugins/gtmLoader.js`
			},
			{
				async: '',
				defer: '',
				id: 'gtm-script'
			});
	}
});


EventDispatcher.addEventListener('cookieNotice:blockingModal:show', () => {
	if (window.Main.cookieNotice.isTargetingCookiesSet) {
		return;
	}
	hideElement('#cookie-notice');
	const cookieNoticeHtml = qs('.cookie-notice__msg div').innerHTML;
	let accepted = false;
	const errorModal = new Modal({
		id: 'searchErrorModal',
		className: 'modal--searchError',
		hideFooter: false,
		hideOnSwipe: true,
		resetScroll: true,
		header: `<div class="title">${l('global.simplePhrases.oops')}</div><span class="icon-circle-cross" data-action="cookieClose"></span>`,
		footer: `<button data-action="cookieNo" class="abBtn--whiteBlue abBtn abBtn--flex">${l('error-page.message.goback')}</button><button id="closeModal" class="abBtn--blueWhite abBtn abBtn--flex" data-action="cookieYes">${l('global.simplePhrases.accept')}</button>`,
		body: `
<div class="abDisplayMessage abDisplayMessage--column abDisplayMessage--withImageBg" style="display: flex;">
	<div class="abDisplayMessage__msg">${l('global.cookie.disclaimer.featureRequiresCookies')}<br><br>${cookieNoticeHtml}</div>
</div>
`,
		onOpen: () => {
			errorModal.html.addEventListener('click', (event) => {
				if (event.target.dataset.action === 'cookieYes') {
					window.Main.cookieNotice.consentCode = 7;
					setCookie('consent', 7, 182);
					accepted = true;
					EventDispatcher.dispatch('cookieNotice:blockingModal:accept');
					EventDispatcher.dispatch('cookieNotice:accept');
					logEvent(events.acceptCookies, eventCategories.cookies);
					errorModal.close();
				} else if (['cookieNo', 'cookieClose'].includes(event.target.dataset.action)) {
					EventDispatcher.dispatch('cookieNotice:blockingModal:decline');
					logEvent(events.declineCookies, eventCategories.cookies);
					errorModal.close();
				}
			});
		},
		onClose: () => {
			if (!accepted) {
				EventDispatcher.dispatch('cookieNotice:blockingModal:decline');
				logEvent(events.declineCookies, eventCategories.cookies);
			}
		}
	});
	errorModal.open();
});
